export async function ensureNotificationPermission() {
  if (typeof window === 'undefined' || !('Notification' in window)) return false;
  if (Notification.permission === 'granted') return true;
  if (Notification.permission === 'denied') return false;
  const result = await Notification.requestPermission();
  return result === 'granted';
}

function shouldShowBrowserNotification() {
  if (typeof document === 'undefined') return false;
  return document.hidden;
}

export function showBrowserNotification(title, options = {}) {
  if (typeof window === 'undefined' || !('Notification' in window)) return;
  if (Notification.permission !== 'granted') return;
  if (!shouldShowBrowserNotification()) return;

  try {
    new Notification(title, {
      body: options.body,
      tag: options.tag,
      icon: '/favicon.ico',
    });
  } catch {
    // ignore
  }
}

export function notifyNewOrder(orderId, customerName, totalCents) {
  const total = totalCents != null
    ? ` · R$ ${(totalCents / 100).toFixed(2).replace('.', ',')}`
    : '';
  const name = customerName ? ` — ${customerName}` : '';
  showBrowserNotification(`Novo pedido #${orderId}`, {
    body: `${name}${total}`.trim(),
    tag: 'new-order-alert',
  });
}

export function notifyNewOrdersGrouped(count) {
  showBrowserNotification(`${count} novos pedidos`, {
    body: 'Confira a tela de pedidos',
    tag: 'new-order-alert',
  });
}
